import type { FC, PropsWithChildren } from 'react';

import { Section } from '@xing-com/layout-primitives';

import { ZenViewSubHeader } from '../zen-view-sub-header/zen-view-sub-header';

import { StyledContainer } from './zen-view.styles';

type ZenViewProps = {
  backLink?: {
    label: string;
    onClose: () => void;
  };
};

export const ZenView: FC<PropsWithChildren<ZenViewProps>> = ({
  children,
  backLink,
}) => {
  return (
    <Section>
      <StyledContainer>
        {backLink ? <ZenViewSubHeader backLink={backLink} /> : null}
        {children}
      </StyledContainer>
    </Section>
  );
};
